import axios from 'axios';

export const getJson = async (path: string, key: string, acc: {}) => {
  acc[key] = (await axios.get(path))?.data;
};
